import { useState } from 'react';
import { Award } from 'lucide-react';
import { cn } from '@mlm/ui';
import { apiPathUrl } from '../../lib/api';

// Static class strings (never interpolated, so Tailwind keeps them) — the
// fallback Award is tinted by rank index so an icon-less ladder still reads.
const TINTS = [
  'bg-amber-100 text-amber-700',
  'bg-slate-100 text-slate-600',
  'bg-yellow-100 text-yellow-700',
  'bg-emerald-100 text-emerald-700',
  'bg-sky-100 text-sky-700',
  'bg-violet-100 text-violet-700',
  'bg-rose-100 text-rose-700',
] as const;

/** Rank icon (API-relative path) with a tinted Award fallback when unset or broken. */
export function RankIcon({
  iconUrl,
  index = 0,
  className,
}: {
  iconUrl: string | null;
  index?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  if (iconUrl && !failed) {
    return (
      <img
        src={apiPathUrl(iconUrl)}
        alt=""
        className={cn('shrink-0 object-contain', className)}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full',
        TINTS[Math.abs(index) % TINTS.length],
        className,
      )}
    >
      <Award className="h-1/2 w-1/2" />
    </span>
  );
}
